// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-indicator-block {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.live-indicator {
    font-family: 'Roboto', sans-serif;
    background: transparent;
    color: #fff;
    padding: 6px 7px;
    line-height: 1;
    border-radius: 6px;
    text-transform: uppercase;
    display: inline-block;
    vertical-align: middle;
    font-size: 12px;
    font-weight: bold;
    width: auto;
}
.blink {
    animation: blinker 1s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
    font-size: 10px;
    margin-right: 5px;
    vertical-align: baseline;
}

@keyframes blinker {
    from { opacity: 1; }
    to { opacity: 0; }
}

.live-indicator-block i {
    display: none !important;
}

.live-indicator-block:hover {
    background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/liveIndicatorButton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;AACpC;AACA;IACI,iCAAiC;IACjC,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,mEAAmE;IACnE,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":[".live-indicator-block {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n.live-indicator {\n    font-family: 'Roboto', sans-serif;\n    background: transparent;\n    color: #fff;\n    padding: 6px 7px;\n    line-height: 1;\n    border-radius: 6px;\n    text-transform: uppercase;\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 12px;\n    font-weight: bold;\n    width: auto;\n}\n.blink {\n    animation: blinker 1s cubic-bezier(0.5, 0, 1, 1) infinite alternate;\n    font-size: 10px;\n    margin-right: 5px;\n    vertical-align: baseline;\n}\n\n@keyframes blinker {\n    from { opacity: 1; }\n    to { opacity: 0; }\n}\n\n.live-indicator-block i {\n    display: none !important;\n}\n\n.live-indicator-block:hover {\n    background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
